// extracted by mini-css-extract-plugin
export default {"map-confirm-controls":"map-confirm-controls_map-confirm-controls__SAKJi","icon-button":"map-confirm-controls_icon-button__-CTNB"};